












import { shuffle } from 'lodash';
import adjectives from '@/lib/adjectives';
import nouns from '@/lib/nouns';
import { Component, Vue } from 'vue-property-decorator';
import {titleCase} from 'change-case';
import api_client from '@/lib/api_client';

@Component
export default class Home extends Vue {
  public randomAdjective = shuffle(adjectives as string[])[0];
  public randomNoun = shuffle(nouns as Array<[]>)[0];

  public form = {
    nickname:
      this.$store.state.profile.nickname || this.$store.state.profile.email,
  };

  public generate() {
    const randomAdjective = shuffle(adjectives as string[])[0];
    const randomNoun = (shuffle(nouns as [])[0] as string[])[0];
    this.form.nickname = `${titleCase(randomAdjective)} ${titleCase(randomNoun)}`;
  }

  public async update() {
    const response = await api_client.put(`/players/${this.$store.state.profile.id}`, {
      nickname: this.form.nickname,
    });
    this.$store.commit('setToken', response.data.token);
    this.$store.commit('setAlert', {type: 'info', text: `You got it ${this.form.nickname}`});
  }
}
